module.exports = __webpack_public_path__ + "img/default.85c98400.svg";